/* https://github.com/beholdr/maska */
import { app } from "@/main";
import Maska from "maska";

app.use(Maska);
